import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../services/api";

// Handles the return from Emergent-managed Google Auth.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { completeGoogleLogin } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        await completeGoogleLogin(sessionId);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/profiles", { replace: true });
      } catch (e) {
        setError(formatApiErrorDetail(e.response?.data?.detail) || "Google sign-in failed.");
        setTimeout(() => navigate("/login", { replace: true }), 2500);
      }
    })();
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen flex flex-col items-center justify-center" style={{ background: "linear-gradient(180deg,#38BDF8,#86EFAC)" }} data-testid="auth-callback">
      <div className="text-7xl animate-floaty">{error ? "😕" : "✨"}</div>
      <p className="font-display text-2xl font-black text-white mt-4 animate-pulse">
        {error ? error : "Signing you in..."}
      </p>
    </div>
  );
}
